// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SessionFiles_box__p-NFq {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-3);
  padding: var(--space-3) 0 var(--space-2);
}

.SessionFiles_list__SchjG {
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
}

.SessionFiles_item__uOE0M {
  padding: var(--space-2) 0;
  border-bottom: 1px solid var(--border-light);
}

.SessionFiles_itemHead__cl9gE {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-2);
}

.SessionFiles_label__xvAZD {
  font-weight: 600;
  min-width: 90px;
}

.SessionFiles_actions__TDvdX {
  display: inline-flex;
  gap: var(--space-1);
}

.SessionFiles_note__Isrb5,
.SessionFiles_when__Z-yBA {
  font-size: 0.875rem;
  color: var(--text-secondary);
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/Admin/SessionFiles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,4BAA4B;EAC5B,SAAS;AACX","sourcesContent":[".box {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: var(--space-3);\n  padding: var(--space-3) 0 var(--space-2);\n}\n\n.list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n}\n\n.item {\n  padding: var(--space-2) 0;\n  border-bottom: 1px solid var(--border-light);\n}\n\n.itemHead {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: var(--space-2);\n}\n\n.label {\n  font-weight: 600;\n  min-width: 90px;\n}\n\n.actions {\n  display: inline-flex;\n  gap: var(--space-1);\n}\n\n.note,\n.when {\n  font-size: 0.875rem;\n  color: var(--text-secondary);\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `SessionFiles_box__p-NFq`,
	"list": `SessionFiles_list__SchjG`,
	"item": `SessionFiles_item__uOE0M`,
	"itemHead": `SessionFiles_itemHead__cl9gE`,
	"label": `SessionFiles_label__xvAZD`,
	"actions": `SessionFiles_actions__TDvdX`,
	"note": `SessionFiles_note__Isrb5`,
	"when": `SessionFiles_when__Z-yBA`
};
export default ___CSS_LOADER_EXPORT___;
